import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./Header.scss";
import HamburgerIcon from "../icons/Hamburger.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog";

export function MobileNav({ isAdmin }) {
  const [navOpen, setNav] = useState(false);
  const menuRef = useRef(null);

  const toggleNav = () => {
    setNav(!navOpen);
  };

  const closeNav = () => {
    setNav(false);
  };

  // メニュー外をクリックしたら閉じる
  useEffect(() => {
    const handleClickOutside = event => {
      if (navOpen && menuRef.current && !menuRef.current.contains(event.target)) {
        closeNav();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [navOpen]);

  return (
    <>
      <div className={styles.navContainer}>
        <div className={styles.mobileNavWrapper} ref={menuRef}>
          <img src={HamburgerIcon} onClick={toggleNav} alt="Menu" style={{ cursor: "pointer" }} />
          <header className={`${navOpen ? "is-active" : "hide"}`}>
            <nav role="navigation">
              <ul>
                <li>
                  <a href="#" onClick={closeNav}>
                    Home
                  </a>
                </li>
                <li>
                  <a href="#vision" onClick={closeNav}>
                    Vision
                  </a>
                </li>
                <li>
                  <a href="#worlds" onClick={closeNav}>
                    Worlds
                  </a>
                </li>
                <li>
                  <a href="#voice" onClick={closeNav}>
                    Voice
                  </a>
                </li>
                <li>
                  <a href="/guide" onClick={closeNav}>
                    使い方ガイド
                  </a>
                </li>
                <li>
                  <a href="/faq" onClick={closeNav}>
                    FAQ
                  </a>
                </li>
                <li>
                  <a href="/contact" onClick={closeNav}>
                    お問い合わせ
                  </a>
                </li>
                {isAdmin && (
                  <li>
                    <a style={{ marginLeft: 0 }} href="/admin" rel="noreferrer noopener" onClick={closeNav}>
                      <i>
                        <FontAwesomeIcon icon={faCog} />
                      </i>
                      &nbsp; Admin
                    </a>
                  </li>
                )}
              </ul>
            </nav>
          </header>
        </div>
      </div>
    </>
  );
}

MobileNav.propTypes = {
  isAdmin: PropTypes.bool
};
